import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ThemeService } from '../../../core/services/theme.service';
import { AuthFacade } from '../../../core/services/auth.facade';
import { TokenService } from '../../../core/services/token.service';
import { AppBreadcrumbComponent } from '../app-breadcrumb/app-breadcrumb.component';
import { AppAvatarComponent } from '../app-avatar/app-avatar.component';
import { AppNotificationBellComponent } from '../app-notification-bell/app-notification-bell.component';
import { AppGlobalSearchComponent } from '../app-global-search/app-global-search.component';

const THEME_ICONS = { light: 'sun', dark: 'moon', auto: 'monitor' } as const;
const THEME_LABELS = { light: 'Claro', dark: 'Oscuro', auto: 'Automático' } as const;

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    RouterLink,
    MatIconModule,
    MatIconButton,
    MatMenuModule,
    MatTooltipModule,
    AppBreadcrumbComponent,
    AppAvatarComponent,
    AppNotificationBellComponent,
    AppGlobalSearchComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './app-header.component.html',
  host: { class: 'flex h-16 shrink-0 items-center gap-2 border-b border-default bg-surface px-4' },
})
export class AppHeaderComponent {
  protected readonly themeService = inject(ThemeService);
  protected readonly tokenService = inject(TokenService);
  private readonly authFacade = inject(AuthFacade);
  private readonly router = inject(Router);

  protected readonly themeIcons = THEME_ICONS;
  protected readonly themeLabels = THEME_LABELS;

  readonly menuToggle = output<void>();

  cycleTheme(): void {
    this.themeService.cycle();
  }

  logout(): void {
    this.authFacade.logout().subscribe(() => void this.router.navigateByUrl('/login'));
  }
}
